import {isMobile} from "../../../util/misc.js";
import {getRelativePosition} from "chart.js/helpers";
import {getAnnotations} from "./_annotation.js";
import {setOverlay} from "./_overlay.js";

export let ANNOTATION_DATA = {
    IS_HOVERING: false,
    HOVER_DATE: null,
}

export const getOptions = ({
                               isZeroBaseValue = false,
                               onMouseLeave = () => {
                               },
                               onMouseEnter = () => {
                               },
                               onMouseMove = dataIndex => console.log(dataIndex),
                               onClick = (dataX, dataY) => console.log({dataX, dataY}),
                               showDates = !isMobile(),
                               chart = null,
                               palette,
                               labels = [],
                               dateFilter,
                               assetId,
                               filterPreset,
                               annotationsRaw,
                               transactionHoverDate,
                               transactionHoverType,
                               transactionHoverAssetCode,
                               transactionHoverAssetCodeFrom,
                               transactionHoverIsProfit,
                               chartTransactions = [],
                               values = [],
                           }) => {

    const annotations = getAnnotations({
        annotationsRaw,
        labels,
        values,
        palette,
        dateFilter,
        assetId,
        filterPreset,
        transactionHoverDate,
        transactionHoverType,
        transactionHoverAssetCode,
        transactionHoverAssetCodeFrom,
        transactionHoverIsProfit,
        chartTransactions,
    })

    return {
        // maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            axis: 'x',
            intersect: false,
        },
        elements: {
            line: {
                tension: 1
            },
        },
        onClick: e => {
            if (chart) {
                const canvasPosition = getRelativePosition(e, chart.current)
                const dataX = chart.current?.scales?.x.getValueForPixel(canvasPosition.x)
                const dataY = chart.current?.scales?.y.getValueForPixel(canvasPosition.y)
                onClick(dataX, dataY)
            }
        },
        events: ['mouseenter', 'mouseleave', 'mouseout', 'mousedown', 'mouseup', 'mousemove'],
        plugins: {
            eventPlugin: {
                events: ['mouseenter', 'mouseleave'],
                onMouseLeave,
                onMouseEnter,
                onClick,
            },
            tooltip: {
                enabled: false,
                external: function (context) {
                    const {dataIndex} = context.tooltip?.dataPoints[0]
                    setOverlay(context)
                    onMouseMove(dataIndex)
                }
            },
            legend: {
                display: false,
            },
            annotation: {
                annotations,
            }
        },
        layout: {
            padding: {
                left: 0
            }
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    round: 'date',
                    displayFormats: {
                        month: 'MMMM YYYY',
                        // hour: 'MM-DD HH:ii'
                    },
                },
                border: {
                    display: showDates,
                },
                ticks: {
                    display: showDates,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: isZeroBaseValue,
                border: {
                    display: !isMobile(),
                },
                ticks: {
                    display: !isMobile(),
                },
                grid: {
                    display: false,
                },
            }
        }
    }
}